import imageCompression from 'browser-image-compression';
import heic2any from 'heic2any';
import { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { BsImage } from "react-icons/bs";
import { Bars, Puff } from "react-loader-spinner";
import { toast } from "react-toastify";
import determineFileType from "../../helpers/fileType";
import { useCategoriesQuery } from "../../service/categoryApi";
import { useAddProductMutation } from "../../service/productApi";
import { uploadImage } from "../../helpers/uploadImage";

const AddClothes = () => {
  const { data } = useCategoriesQuery();
  const [name, setName] = useState("");
  const [brand, setBrand] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("select category");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [shipping, setShipping] = useState("select shipping");
  const [addProduct] = useAddProductMutation();
  const [subCategory, setSubCategory] = useState("select sub-category");
  const [condition, setCondition] = useState("");
  const [selectedCat, setSelectedCat] = useState({});
  const [variant, setVariant] = useState("");
  const [sCheck, setSCheck] = useState(false);
  const [sQuantity, setSQuantity] = useState(0);
  const [mCheck, setMCheck] = useState(false);
  const [mQuantity, setMQuantity] = useState(0);
  const [lCheck, setLCheck] = useState(false);
  const [lQuantity, setLQuantity] = useState(0);
  const [xlCheck, setXlCheck] = useState(false);
  const [xlQuantity, setXlQuantity] = useState(0);
  const [twoXlCheck, setTwoXlCheck] = useState(false);
  const [twoXlQuantity, setTwoXlQuantity] = useState(0);
  const shippingData = [
    {
      name: "Small box up to 2kg £3.99",
      value: 3.99,
    },
    {
      name: "Medium box up to 10kg £6.80",
      value: 6.80,
    },
    {
      name: "Large box up to 20kg £11",
      value: 11,
    },
    {
      name: "Large letter up to 1kg £2.70",
      value: 2.70,
    },
      {
      name: "Evri Parcel - £2.94",
      value: 2.94,
    },
  ];

  const handleImageUpload = async (e) => {
    setLoading(true);

    if (!e.target.files || e.target.files.length === 0) {
      setLoading(false);
      return;
    }

    // Process each file
    for (let i = 0; i < e.target.files.length; i++) {
      try {
        let file = e.target.files[i];
        let fileName = file.name;

        // Cloud Run rejects requests over 32MB before they reach the server.
        const MAX_UPLOAD_BYTES = 31 * 1024 * 1024;

        // Videos can't go through image compression — upload them as-is.
        if (file.type.startsWith('video/')) {
          if (file.size > MAX_UPLOAD_BYTES) {
            toast.error(`${fileName} is too large (max 31MB). Skipping...`);
            continue;
          }
          const url = await uploadImage(file);
          setImages((prevImages) => [...prevImages, url]);
          continue;
        }

        // Check if file is HEIC
        if (file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic')) {
          try {
            // Convert HEIC to PNG
            const convertedBlob = await heic2any({
              blob: file,
              toType: 'image/png',
              quality: 0.8
            });
            
            // Create a new file from the converted blob
            file = new File([convertedBlob], fileName.replace(/\.heic$/i, '.png'), {
              type: 'image/png'
            });
            fileName = file.name;
          } catch (error) {
            console.error('Error converting HEIC:', error);
            toast.error('Failed to convert HEIC image. Skipping...');
            continue;
          }
        }

        // Compress the image (no resizing, just quality)
        try {
          file = await imageCompression(file, {
            maxSizeMB: 8,
            maxWidthOrHeight: 2560,
            initialQuality: 0.7,
            useWebWorker: true
          });
        } catch (compressionError) {
          console.error('Error compressing image:', compressionError);
          toast.error('Failed to compress image. Skipping...');
          continue;
        }

        // Upload via our API, which stores the file in Google Cloud Storage.
        const url = await uploadImage(file);
        setImages((prevImages) => [...prevImages, url]);
      } catch (error) {
        console.error('Error uploading file:', error);
        toast.error(`Failed to upload ${e.target.files[i].name}: ${error.message}`);
      }
    }

    setLoading(false);
  };
  const handleRemove = (img) => {
    const filter = images.filter((i) => i !== img);
    setImages(filter);
  };

  const handleCategory = (e) => {
    setCategory(e.target.value);
    const selected = data?.data?.find(
      (value) => value.value === e.target.value
    );
    setSelectedCat(selected);
  };

  const handleAddProduct = async () => {
    const data = {
      name,
      description,
      images,
      category,
      price: parseFloat(price),
      cquantity: [
        { name: "s", quantity: parseInt(sQuantity) },
        { name: "m", quantity: parseInt(mQuantity) },
        { name: "l", quantity: parseInt(lQuantity) },
        { name: "xl", quantity: parseInt(xlQuantity) },
        { name: "2xl", quantity: parseInt(twoXlQuantity) },
      ],
      brand,
      shipping,
      subCategory,
      condition,
      variant,
    };
    console.log(data);
    if (images.length > 0) {
      if (
        name &&
        description &&
        category &&
        condition &&
        variant &&
        price &&
        brand &&
        shipping &&
        (parseInt(sQuantity) > 0 ||
          parseInt(mQuantity) > 0 ||
          parseInt(lQuantity) > 0 ||
          parseInt(xlQuantity) > 0 ||
          parseInt(twoXlQuantity) > 0)
      ) {
        setAddLoading(true);

        addProduct(data).then((res) => {
          if (res?.data?.status) {
            toast.success(res?.data?.message);
            setName("");
            setImages([]);
            setDescription("");
            setBrand("");
            setPrice("");
            setCondition("");
            setCategory("select category");
            setAddLoading(false);
            setCategory("select category");
            setSelectedCat({});
            setShipping("select shipping");
            setSubCategory("select sub-category");
            setSCheck(false);
            setXlCheck(false);
            setMCheck(false);
            setLCheck(false);
            setTwoXlCheck(false);
            setSQuantity(0);
            setMQuantity(0);
            setLQuantity(0);
            setXlQuantity(0);
            setTwoXlQuantity(0);
            setVariant("");
          } else {
            toast.error(res?.data?.message);
            setAddLoading(false);
          }
        });
      } else {
        toast.error("Please Fill All the required fields!");
      }
    } else {
      toast.error("Please Add at least one image!");
    }
  };
  return (
    <div className="bg-gray-700 my-[20px] rounded p-[20px]">
      <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
        Add Clothes
      </h3>
      <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Brand</label>
          <input
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
      </div>
      <div className="grid md:grid-cols-3 lg:grid-cols-3 gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Price</label>
          <input
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Variant</label>
          <input
            value={variant}
            onChange={(e) => setVariant(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Condition</label>
          <input
            value={condition}
            onChange={(e) => setCondition(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Shipping</label>
          <select
            value={shipping}
            onChange={(e) => setShipping(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
          >
            <option value={"select shipping"}>Select Shipping</option>

            {shippingData?.map((d) => (
              <option key={d?.name} value={d?.value}>
                {d?.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Category</label>
          <select
            value={category}
            onChange={handleCategory}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
          >
            <option value={"select category"}>Select Category</option>
            {data?.data?.map((d) => (
              <option key={d?._id} value={d?.value}>
                {d?.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Sub Category</label>
          <select
            value={subCategory}
            onChange={(e) => setSubCategory(e.target.value)}
            disabled={selectedCat?._id ? false : true}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
          >
            <option value={"select sub-category"}>Select Sub-Category</option>
            {selectedCat?.subCategories?.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="grid gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded focus:border-0 h-[200px]"
            cols={12}
          />
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Size and Quantity</label>
          <div className="mb-3">
            <div className=" flex justify-start items-center">
              <div className="flex justify-start items-center w-[200px]">
                <input
                  type="checkbox"
                  checked={sCheck}
                  onChange={(e) => setSCheck(e.target.checked)}
                  className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                  id="sCheck"
                />
                <label
                  for="sCheck"
                  className="text-white text-[16px] font-semibold ml-[12px]"
                >
                  Small(S)
                </label>
              </div>

              {sCheck && (
                <input
                  type="number"
                  value={sQuantity}
                  placeholder="Quantity(S)"
                  onChange={(e) => setSQuantity(e.target.value)}
                  className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                />
              )}
            </div>
          </div>
          <div className="mb-3">
            <div className=" flex justify-start items-center">
              <div className="flex justify-start items-center w-[200px]">
                <input
                  type="checkbox"
                  checked={mCheck}
                  onChange={(e) => setMCheck(e.target.checked)}
                  id="mCheck"
                  className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                />
                <label
                  for="mCheck"
                  className="text-white text-[16px] font-semibold ml-[12px]"
                >
                  Medium(M)
                </label>
              </div>

              {mCheck && (
                <input
                  type="number"
                  value={mQuantity}
                  placeholder="Quantity(M)"
                  onChange={(e) => setMQuantity(e.target.value)}
                  className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                />
              )}
            </div>
          </div>
          <div className="mb-3">
            <div className=" flex justify-start items-center">
              <div className="flex justify-start items-center w-[200px]">
                <input
                  type="checkbox"
                  checked={lCheck}
                  id="lCheck"
                  onChange={(e) => setLCheck(e.target.checked)}
                  className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                />
                <label
                  for="lCheck"
                  className="text-white text-[16px] font-semibold ml-[12px]"
                >
                  Large(L)
                </label>
              </div>
              {lCheck && (
                <input
                  type="number"
                  value={lQuantity}
                  placeholder="Quantity(L)"
                  onChange={(e) => setLQuantity(e.target.value)}
                  className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                />
              )}
            </div>
          </div>
          <div className="mb-3">
            <div className=" flex justify-start items-center">
              <div className="flex justify-start items-center w-[200px]">
                <input
                  type="checkbox"
                  checked={xlCheck}
                  onChange={(e) => setXlCheck(e.target.checked)}
                  id="xlCheck"
                  className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                />
                <label
                  for="xlCheck"
                  className="text-white text-[16px] font-semibold ml-[12px]"
                >
                  Extra-Large(XL)
                </label>
              </div>

              {xlCheck && (
                <input
                  type="number"
                  value={xlQuantity}
                  placeholder="Quantity(XL)"
                  onChange={(e) => setXlQuantity(e.target.value)}
                  className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                />
              )}
            </div>
          </div>
          <div className="mb-3">
            <div className=" flex justify-start items-center">
              <div className="flex justify-start items-center w-[200px]">
                <input
                  type="checkbox"
                  checked={twoXlCheck}
                  onChange={(e) => setTwoXlCheck(e.target.checked)}
                  id="twoXlCheck"
                  className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                />
                <label
                  for="twoXlCheck"
                  className="text-white text-[16px] font-semibold ml-[12px]"
                >
                  Extra-Extra-Large(2XL)
                </label>
              </div>

              {twoXlCheck && (
                <input
                  type="number"
                  value={twoXlQuantity}
                  placeholder="Quantity(2XL)"
                  onChange={(e) => setTwoXlQuantity(e.target.value)}
                  className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="grid gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Product Images</label>
          <div>
            <label
              className="text-[1.5rem] flex items-center gap-[.5rem] justify-center w-[100%] h-[100px] bg-gray-900 cursor-pointer text-white"
              htmlFor="banner"
            >
              {loading ? (
                <Bars
                  height="80"
                  width="80"
                  color="#fff"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              ) : (
                <>
                  <BsImage /> Upload Image
                  <input
                    onChange={handleImageUpload}
                    className="hidden"
                    type="file"
                    name="banner"
                    id="banner"
                    multiple
                    accept="image/*,.heic"
                  />
                </>
              )}
            </label>
          </div>
          {images.length > 0 && (
            <>
              <p className="text-white font-semibold text-[13px] mt-[15px]">
                Uploaded Images
              </p>
              <div className="flex justify-start items-center gap-[10px]">
                {images?.map((image) => (
                  <>
                    {determineFileType(image) === "video" ? (
                      <div key={image} className="relative">
                        <video
                          className="h-[200px] w-[200px] bg-slate-500"
                          key={image}
                          src={image}
                          alt="images"
                          controls
                          autoPlay={false}
                        />
                        <AiFillCloseCircle
                          style={{ color: "white" }}
                          className="h-[28px] w-[28px] absolute top-[10px] right-[10px]"
                          onClick={() => handleRemove(image)}
                        />
                      </div>
                    ) : (
                      <div key={image} className="relative">
                        <img
                          className="h-[200px] w-[200px]"
                          key={image}
                          src={image}
                          alt="images"
                        />
                        <AiFillCloseCircle
                          style={{ color: "white" }}
                          className="h-[28px] w-[28px] absolute top-[10px] right-[10px]"
                          onClick={() => handleRemove(image)}
                        />
                      </div>
                    )}
                  </>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      <div className="grid gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <button
            onClick={handleAddProduct}
            className="bg-[#47db47] px-[20px] py-[13px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232] flex justify-center items-center"
          >
            {addLoading ? (
              <Puff
                height="25"
                width="25"
                radius={1}
                color="#fff"
                ariaLabel="puff-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
            ) : (
              "Add Product"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddClothes;
